import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleRemove: (id: number) => void, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Step id',
  },
  {
    dataType: IDataType.string,
    dataField: 'stepName',
    width: '20%',
    caption: 'Name',
  },
  {
    dataField: 'capacityCategoryName',
    width: '15%',
    caption: 'Capacity category',
    lookupPickBy: 'capacityCategoryName',
  },
  {
    dataType: IDataType.string,
    dataField: 'stepDescription',
    width: '52%',
    caption: 'Description',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleRemove, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleRemove, translate) => {
  return (
    <DataGridButton
      hint={translate!('Remove', '')}
      icon="remove"
      stylingMode="contained"
      cellData={cellData}
      onClick={() => handleRemove(cellData)}
    />
  );
};
